import http, { HttpSuccessOrErrorType } from '../http';
import { AxiosRequestConfig } from 'axios';
export default {
    /**
     * 改名Restaurant资源的secret_key
     * @param params 参数
     */
    async patch_restaurant_string_id_secret_key(params: { string_id: string, name: string, _id: string }, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<any>> {
        const { string_id, ...rest } = params
        return await http.patch(`/restaurant/${string_id}/secret_key`, {
            ...rest
        }, config)
    },

    /**
     * 刷新Restaurant资源的secret_key。
     * @param params 参数
     */
    async patch_restaurant_string_id_secret_key_refresh(params: { string_id: string, _id: string }, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<any>> {
        const { string_id, ...rest } = params
        return await http.patch(`/restaurant/${string_id}/secret_key/refresh`, {
            ...rest
        }, config)
    },

    /**
     * 删除Restaurant资源的secret_key。
     * @param params 参数
     */
    async delete_restaurant_string_id_secret_key(params: { string_id: string, _id: string }, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<any>> {
        const { string_id, ...rest } = params
        return await http.delete(`/restaurant/${string_id}/secret_key`, {
            data: { ...rest },
            ...config
        })
    },
}